import type { RouteObject } from "react-router-dom";

import { promoRoutes } from "./promo/routes";

export const metaMechanicsRoutes: Array<RouteObject> = [...promoRoutes];
